import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
import dayjs from 'dayjs';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';

/** 포트폴리오 상세 > 손익재무 > 주요재무표 스켈레톤 */
const BalanceSheetSkeleton = () => {
  /** 테이블 헤더 */
  const TABLE_HEADER: any[] = [
    {
      label: '주요재무정보',
      value: 'type',
    },
    {
      label: dayjs().subtract(3, 'year').month(11).format('YYYY-MM'),
      value: dayjs().subtract(3, 'year').month(11).format('YYYY-MM'),
      width: '28%',
      textAlign: 'right',
    },
    {
      label: dayjs().subtract(2, 'year').month(11).format('YYYY-MM'),
      value: dayjs().subtract(2, 'year').month(11).format('YYYY-MM'),
      width: '28%',
      textAlign: 'right',
    },
    {
      label: dayjs().subtract(1, 'year').month(11).format('YYYY-MM'),
      value: dayjs().subtract(1, 'year').month(11).format('YYYY-MM'),
      width: '28%',
      textAlign: 'right',
    },
  ];

  const tableData = useMemo(
    () => [
      {
        id: '매출',
        type: (
          <div css={[items, { justifyContent: 'center' }]}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        [`${dayjs().subtract(3, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(2, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(1, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      },
      {
        id: '영업이익',
        type: (
          <div css={[items, { justifyContent: 'center' }]}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        [`${dayjs().subtract(3, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(2, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(1, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      },
      {
        id: '순이익',
        type: (
          <div css={[items, { justifyContent: 'center' }]}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        [`${dayjs().subtract(3, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(2, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(1, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      },
      {
        id: '자산',
        type: (
          <div css={[items, { justifyContent: 'center' }]}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        [`${dayjs().subtract(3, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(2, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(1, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      },
      {
        id: '자본',
        type: (
          <div css={[items, { justifyContent: 'center' }]}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        [`${dayjs().subtract(3, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(2, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(1, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      },
      {
        id: '부채',
        type: (
          <div css={[items, { justifyContent: 'center' }]}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        [`${dayjs().subtract(3, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(2, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        [`${dayjs().subtract(1, 'year').month(11).format('YYYY-MM')}`]: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      },
    ],
    []
  );

  return (
    <>
      <div css={[titleStyle, { marginTop: '40px' }]}>
        <Skeleton variant="text" width={80} />
      </div>
      <Table header={TABLE_HEADER} data={tableData} />
    </>
  );
};

export default BalanceSheetSkeleton;

const items = css`
  display: flex;
  justify-content: right;
`;
